import { CSSProperties } from "react";

export enum BtnTypes {
  primary = "primary-btn",
  green = "green-btn",
  secondary = "secondary-btn",
  neutral = "neutral-btn",
  venDolsy = "veny-dolsy-btn",
  semi_small = "semi-small-btn",
  semi_small_no_border = "semi-small-btn border-none",
  primary_not_selected = "primary-btn not-selected",
  paginate = "paginate-btn",
  error = "primary-btn danger",
  appointment_cancelled = "primary-btn cancelled",
  primary_not_selected_like = "primary-btn not-selected-like",
  secondary_no_border = "secondary-btn border-none",
  gray4 = "primary-btn gray4",
}
export enum BtnSizes {
  small = "small",
  medium = "medium",
  large = "large",
  option = "option",
  semi_small = "semi-small",
  x_large = "x-large",
}
export enum BtnRadius {
  none = "",
  small = "small-round",
  medium = "medium-round",
  large = "rounded",
  semi_small = "semi-small-round",
  righ_small = "righ-small-round",
  left_small = "left-small-round",
}

interface Props {
  type: BtnTypes;
  size: BtnSizes;
  radius: BtnRadius;
  onClick?: () => void;
  children: any;
  notAllowed?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  isSubmit?: boolean;
  noBorder?: boolean;
  noPadding?: boolean;
  style?: CSSProperties;
  className?: string;
  id?: string;
}

const CustomButton: React.FC<Props> = ({
  type,
  size,
  radius,
  onClick,
  children,
  notAllowed = false,
  disabled = false,
  fullWidth = false,
  isSubmit = false,
  noBorder = false,
  noPadding = false,
  style,
  id,
  className: propsClassName,
}) => {
  let className = `${type} ${size} ${radius}`;
  if (disabled) className += " disabled";
  if (fullWidth) className += " w-100";
  if (noBorder) className += " border-none";
  if (noPadding) className += " padding-none";
  return (
    <button
      id={id!}
      style={style}
      type={isSubmit ? "submit" : "button"}
      className={`${className} ${propsClassName}`}
      disabled={notAllowed}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default CustomButton;
